'use client';

// Context
import { HomepageProvider } from "@src/context/homepage-office-ctx";

// Components
import Hero from "@src/components/organism/homepage-office/hero";
import ListProperty from "@src/components/organism/homepage-office/list-property";

// Components shared
import Navbar from "@src/components/organism/shared/navbar-office";
import NavbarMobile from "@src/components/organism/shared/navbar-mobile-office";
import Footer from "@src/components/organism/shared/footer-office";
import GoldenProperty from '@src/components/organism/shared/golder-property';
import { DedicatedImage } from '@src/components/organism/shared/dedicated';

const Homepage = (detail) => {
  return (
    <HomepageProvider {...detail}>
      <div>
        <Navbar />
        <div className="hidden dd2-xl:block">
          <NavbarMobile />
        </div>

        <Hero {...detail} />
        <ListProperty />
        <DedicatedImage />
        <GoldenProperty />
        <Footer />
      </div>
    </HomepageProvider>
  )
}

export default Homepage